import React from "react";
import ReviewBase from "../../../../common/ReviewBase";

export default function Review(formData) {
  console.log("REIVEW DATA IS:", formData);
  return <ReviewBase formData={formData.formValues} />;
}
